import _ from 'lodash';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';

// ** Article Details Selectors **//
export const getSelectedArticle = createSelector(
  store => _.get(store, 'support.selectedArticleSlug'),
  store => _.get(store, 'support.loadedArticles'),
  (selectedArticleSlug, articles) => {
    if (articles) {
      return articles[selectedArticleSlug];
    }
    return null;
  },
);

export const topicCardPropTypes = {
  fields: PropTypes.shape({
    title: PropTypes.string,
    summary: PropTypes.string,
    iconAssetId: PropTypes.string,
    slug: PropTypes.string,
  }),
};

// TODO: Change this to a text entry?
export const textPropTypes = {
  fields: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    slug: PropTypes.string,
  }),
};

export const articlePropTypes = {
  fields: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
    entries: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.shape(textPropTypes),
    ])),
  }),
};

export const topicPropTypes = {
  ...topicCardPropTypes,
  articles: PropTypes.arrayOf(PropTypes.shape(articlePropTypes)),
};

export const stepPropTypes = {
  title: PropTypes.string,
  summary: PropTypes.string,
  image: PropTypes.shape({
    title: PropTypes.string,
    file: PropTypes.shape({ url: PropTypes.string }),
  }),
  imageTwo: PropTypes.shape({
    title: PropTypes.string,
    file: PropTypes.shape({ url: PropTypes.string }),
  }),
};

export const instructionsPropTypes = {
  title: PropTypes.string,
  summary: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.shape(stepPropTypes)),
};



// WEBPACK FOOTER //
// ./app/selectors/support.js